module.exports = __webpack_public_path__ + "static/advisory-df89a8bb0cfd9f89e8f21be49e35c44f.svg";